import { gql } from 'apollo-boost';

export const SET_MESSAGE_SILENT = gql`
  mutation SetMessageSilent(
    $_id: ID!
    $silentDeleted: Boolean!
    $reason: String
  ) {
    setMessageSilentDeleted(
      _id: $_id
      silentDeleted: $silentDeleted
      reason: $reason
    ) {
      _id
      silentDeleted
      silentModerationAt
      silentModerationBy
      silentModerationReason
      moderationHistory { action actor reason at reportId }
    }
  }
`;
export const SET_COMMENT_SILENT = gql`
  mutation SetCommentSilent(
    $_id: ID!
    $silentDeleted: Boolean!
    $reason: String
  ) {
    setCommentSilentDeleted(
      _id: $_id
      silentDeleted: $silentDeleted
      reason: $reason
    ) {
      _id
      silentDeleted
      silentModerationAt
      silentModerationBy
      silentModerationReason
      moderationHistory { action actor reason at reportId }
    }
  }
`;
export const SILENTLY_DELETE_REPORTED = gql`
  mutation SilentlyDeleteReported($_id: ID!, $reason: String) {
    silentlyDeleteReported(_id: $_id, reason: $reason) {
      _id
      handled
      relatedMsg {
        _id
        silentDeleted
      }
      relatedCom {
        _id
        silentDeleted
      }
    }
  }
`;
